module.exports = __webpack_public_path__ + "static/mobile-bg.1f55935c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/mobile-bg.jpg
// module id = 236
// module chunks = 35783957827783 95715928098905 172322841747965